import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PositionAndDirection',
  field: 'Geometry',
  weeks: [6, 6],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'DescribeTurns',
      questionTypes: ['beI', 'beJ', 'beK'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/1DescribeTurns" */ './1DescribeTurnsModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'DescribePositionLeftAndRight',
      questionTypes: ['beL', 'beM', 'beN'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/2DescribePositionLeftAndRight" */ './2DescribePositionLeftAndRightModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'DescribePositionForwardsAndBackwards',
      questionTypes: ['beO', 'beP', 'beQ'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/3DescribePositionForwardsAndBackwards" */ './3DescribePositionForwardsAndBackwardsModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'DescribePositionAboveAndBelow',
      questionTypes: ['beR', 'beS', 'beT'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/4DescribePositionAboveAndBelow" */ './4DescribePositionAboveAndBelowModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'OrdinalNumbers',
      questionTypes: ['beU', 'beV', 'beW'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/PositionAndDirection/5OrdinalNumbers" */ './5OrdinalNumbersModels'
        )
    })
  ]
});
export default Block;
